import { connect } from 'react-redux';
import { getTradeNotificationsContacts } from 'state/quotes/trades/trades.selectors';
import { getFormQuoteId } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
  className?: string;
  onContactIdsChanged: (value: string[]) => void;
}

interface StateProps {
  contactIds?: string[];
}

export type TradeNotificationsProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = getFormQuoteId(state, workspaceType, tabId);
  const contactIds = getTradeNotificationsContacts(state, quoteId);

  return {
    contactIds,
  };
};

export const connectTradeNotifications = connect(mapStateToProps);
